import { useEffect, useState } from "react";
import adminApi from "../../../../../configs/apis/admins";
import CreateAdminDialogComponent from "./createAdminDialog.component";
import adminRolesApi from "../../../../../configs/apis/admin-roles";

export default function CreateAdminDialogContainer({
  open,
  handleClose,
  handleSubmit,
}) {
  const [companyGroupOptions, setCompanyGroupOptions] = useState(null);
  const [roleOptions, setRoleOptions] = useState(null);

  useEffect(async () => {
    await adminApi.getCompanyGroupDropdown()
      .then((response) => {
        setCompanyGroupOptions(response.data);
      });

    await adminRolesApi.roleDropdown()
      .then((response) => {
        setRoleOptions(response.data);
      });
  }, []);

  return (
    <CreateAdminDialogComponent
      open={open}
      handleSubmit={handleSubmit}
      handleClose={handleClose}
      roleOptions={roleOptions}
      companyGroupOptions={companyGroupOptions}
    />
  );
}
